/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import "./discourse.css";
import { ColoredDividerThin } from "../ColoredDivider/ColoredDivider";
import Button from "react-bootstrap/Button";
import gauge_easy from "../../assets/images/gauge_easy.png";
import gauge_ok from "../../assets/images/gauge_ok.png";
import gauge_hard from "../../assets/images/gauge_hard.png";
import avatar from "../../assets/images/avatar.png";
import WriteCommentModal from "../Modals/WriteCommentModal";
import Parse from "parse/dist/parse.min.js";

export default function DiscourseForum({
  forumEnabled,
  scrollSize,
  setIsCommentModalOpen,
  idAsNumber,
  langString,
  formattedComments,
}) {
  const handleOpenCommentModal = () => setIsCommentModalOpen(true);
  const inlineStyle = {
    position: scrollSize ? "sticky" : "",
    bottom: scrollSize ? "25px" : "",
    opacity: scrollSize ? 1 : "",
    transition: scrollSize ? "all 0.5s ease-out" : "",
  };

  // useEffect(() => {
  //   loadComments();
  // }, []);

  // async function loadComments() {
  //   try {
  //     console.log("loadComments");

  //     const Riddle = Parse.Object.extend("ExtRiddle");
  //     const tempQuery = new Parse.Query(Riddle);
  //     tempQuery.equalTo("extIdNumber", idAsNumber);
  //     const results = await tempQuery.find();

  //     const object = results[0];
  //     var relation = object.get("commentRelations2");
  //     var relationQuery = relation.query();
  //     const commentsArray = await relationQuery.find();
  //     setFormattedComments(commentsArray.map((comment, index) => ({
  //       id: index + 1,
  //       avatar: comment.get("profileImage")?.url() || avatar,
  //       username: comment.get("userName") || "Anonymous",
  //       text: comment.get("text") || "",
  //       difficulty: comment.get("rating") || "Unknown",
  //     })) || []);

  //     console.log("Formatted Comments:", formattedComments, idAsNumber);
  //   } catch (error) {
  //     console.error("Comments error:", error);
  //   }
  // }

  // const navigateTo = () => {
  //   const currentDate = new Date();
  //   const dayNumber = currentDate.getDate();
  //   let discourseNumber = dayNumber + 21;

  //   if (discourseNumber === 49) {
  //     discourseNumber = 55;
  //   }

  //   window.open(`https://smartfriends.discourse.group/t/${discourseNumber}`, "_blank");
  // };

  if (!forumEnabled) return null;


  const renderDifficultyIcon = (difficulty) => {
    let iconSrc;
    // console.log(difficulty);
    switch (difficulty) {
      case "Too Easy":
      case 0:
        iconSrc = gauge_easy;
        break;
      case "Good":
      case 1:
        iconSrc = gauge_ok;
        break;
      case "Too Hard":
      case 2:
        iconSrc = gauge_hard;
        break;
      default:
        iconSrc = "";
    }
    return (
      <img
        src={iconSrc}
        alt={difficulty}
        style={{
          width: "50px",
          height: "50px",
          marginLeft: "auto",
        }}
      />
    );
  };

  return (
    <div className="comments" style={{ padding: "0 16px" }}>
      <h2
        className="comments-header"
        style={{
          fontSize: "2rem",
          margin: "16px 0",
          textAlign: "center",
          fontFamily: "Union",
        }}
      >
        {langString === "nl" ? "Reacties" : "Comments"}
      </h2>

      {formattedComments.length === 0 && (
        <p
          style={{
            textAlign: "center",
            fontFamily: "Union",
            fontSize: "1.5rem",
            color: "#999",
            marginTop: "30px",
            marginBottom: "50px",
          }}
        >
          {langString === "nl" ? "Nog geen reacties" : "No comments yet"}
        </p>
      )}

      {!!formattedComments.length &&
        formattedComments.map((item) => (
          <div key={item.id}>
            <div
              className="comment-container"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <div style={{ display: "flex", alignItems: "start" }}>
                <img
                  src={item.avatar}
                  alt={`${item.username} avatar`}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    border: "2px solid #0056b3", // Blue border
                  }}
                />
                <div style={{ marginLeft: "10px" }}>
                  <p
                    style={{
                      margin: "0",
                      fontWeight: "bold",
                      fontFamily: "Union",
                      fontSize: "1.7rem",
                    }}
                  >
                    {item.username}
                  </p>
                  {item.text && (
                    <p
                      style={{
                        margin: "4px 0 0",
                        fontFamily: "Union",
                        fontSize: "1.5rem",
                      }}
                    >
                      {item.text}
                    </p>
                  )}
                </div>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "start",
                  width: "-webkit-fill-available",
                }}
              >
                {renderDifficultyIcon(item.difficulty)}
              </div>
            </div>
            <ColoredDividerThin />
          </div>
        ))}
      {/* 
      <div onClick={navigateTo} style={{ ...inlineStyle, marginTop: "20px" }} className="button">
        <Button style={{ width: "100%", backgroundColor: "#2a00b5", borderColor: "#2a00b5" }}>
          Write a comment
        </Button>
      </div> */}

      <div
        onClick={handleOpenCommentModal}
        style={{ ...inlineStyle, marginTop: "20px" }}
        className="button"
      >
        <Button
          style={{
            width: "100%",
            backgroundColor: "#2a00b5",
            borderColor: "#2a00b5",
          }}
        >
          {langString === "nl" ? "Schrijf een reactie" : "Write a comment"}
        </Button>
      </div>
    </div>
  );
}
